import Vue from 'vue'
import store from '../store'

const state = {}

const actions = {
  UNSUBSCRIBE: ({commit}, order) => {
    commit('SET_IS_VERIFYING', true)
    const url = 'subscriptions/' + order.subscription_id + '/unsubscribe'
    const submitData = {
      order_id: order.id
    }

    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          store.dispatch('orderDetail/loadOrderDetail', order.id)
        }
      })
  }
}

const mutations = {}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/subscription.js